<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :row-style="rowStyleFun"
      :before-reset-search="beforeResetSearch"
      :before-query-search="beforeQuerySearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
          <el-col :span="colSpan">
            <BjFormItemCode v-model="queryParams.code" :placeholder="$t('BusinessPurchaseOrder2.code')" @keyup.enter.native="handleQuery" />
          </el-col>
          <!-- <el-col :span="colSpan">
            <BjFormItemCode v-model="queryParams.thirdCode" :placeholder="$t('BusinessPurchaseOrder2.externalPo')" />
          </el-col> -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseEntryComView.statusMeaning')" prop="status">
              <BjSelectLov v-model="statusList" :placeholder="$t('BusinessPurchaseEntryComView.statusMeaning')" multiple :option-list="statusOptionList" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessAfterCsgReturn.table.cusName')">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.Unit')" prop="shippingMethod">
              <BjSelectLov v-model="queryParams.shippingMethod" :placeholder="$t('BusinessPurchaseOrder2.Unit')" :option-list="SHIPPING_METHODS" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessBatchInventoryQuery.table.skuCode')" prop="skuCode">
              <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessBatchInventoryQuery.table.skuCode')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col v-if="isOpen" :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.dialog.arriveDate')">
              <BjDateTimerPicker v-model="queryParams.deliveryTimeEnd" :tip-show="false" :placeholder="$t('BusinessPurchaseOrder2.dialog.arriveDate')" />
            </el-form-item>
          </el-col>
          <el-col v-if="!isOpen" :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrderDetail.finishTime')">
              <BjDateRangePicker v-model="queryParamsTime_finish" :placeholder="$t('BusinessPurchaseOrderDetail.finishTime')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <BjFormItemCode v-model="queryParams.containerId" :placeholder="$t('BusinessPurchaseOrder2.container')" @keyup.enter.native="handleQuery" />
          </el-col>
      </template>
      <!-- <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs
            :value="tabsValue"
            :option-list="TAB_LIST"
            @handleTabClick="handleTabClick"
          />
        </el-col>
      </template> -->
      <template v-slot:tableOperation>
        <el-col>
          <!-- <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button> -->
          <BjFrontendExport
            :disabled="!selectedRows.length"
            type="primary"
            :label-list="exportLabelList"
            :rows="selectedRows"
            :file-name="exportFileName"
            worksheet="worksheet1"
            @export-success="resetAfterExport"
          />
          <el-button v-if="isOpen" v-permission:BusinessPurchaseOrderDelete type="primary" @click="onDeleteSelected">{{ $t('delText') }}</el-button>
          <el-button type="primary" @click="onSync">{{ $t('BusinessPurchaseOrder2.updateStatus') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(row.cusId) }}</template>
              <template v-else-if="col.prop === 'code'">
                <span class="link" @click="onDetail(row)">{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'thirdCode'">
                <span>{{ row.shippingMethod == 'Container' ? row.containerId : row.thirdCode }}</span>
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :min-width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button v-permission:BusinessPurchaseOrderCsgAdminDetail type="text" class="delete-btn" @click="onDetail(row)">{{ $t('BusinessPurchaseOrderList.View') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="command($event, row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="row.status === 'New'" command="arrive">{{ $t('BusinessPurchaseOrder2.dialog.arrivedBtn') }} </el-dropdown-item>
                  <!-- <el-dropdown-item v-if="showVerifyBtn.includes(row.status)" v-permission:BusinessPurchaseOrderCsgAdminVerify command="verify"> {{ $t('BusinessPurchaseOrder2.dialog.verifyBtn') }} </el-dropdown-item> -->
                  <el-dropdown-item v-if="row.status === 'Arrived' || row.status === 'Receiving' || row.status === 'In Progress'" v-permission:BusinessPurchaseOrderCsgAdminReceive command="receive"> {{ $t('BusinessPurchaseOrder2.dialog.receiveBtn') }} </el-dropdown-item>
                  <el-dropdown-item v-if="(showFCL.includes(row.status) && row.shippingMethod == 'Container')||row.status == 'Received'" :disabled="row.containerReadyTime" command="fclRdy"> {{ $t('BusinessPurchaseOrder2.dialog.fclRdyBtn') }} </el-dropdown-item>
                  <el-dropdown-item v-if="(showFCL.includes(row.status) && row.shippingMethod == 'Container')||row.status == 'Received'" :disabled="!row.containerReadyTime || row.containerEndTime" command="fclPick"> {{ $t('BusinessPurchaseOrder2.dialog.fclPickBtn') }} </el-dropdown-item>
                  <el-dropdown-item v-if="(showFCL.includes(row.status) && row.shippingMethod == 'Container')||row.status == 'Received'" :disabled="!row.containerEndTime" command="completed"> {{ $t('Completed') }} </el-dropdown-item>

                  <el-dropdown-item v-if="row.status === 'UploadFail'" command="push"> {{ $t('BusinessPurchaseOrder2.dialog.pushBtn') }} </el-dropdown-item>
                  <el-dropdown-item v-if="row.status === 'New'" v-permission:BusinessPurchaseOrderCsgAdminEdit command="edit"> {{ $t('editText') }} </el-dropdown-item>
                  <el-dropdown-item v-if="row.status === 'New'" command="cancel"> {{ $t('cancelText') }} </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  <!-- 到货弹窗  -->
    <BjDialog :title="arrivedDialogTitle" :visible="arrive_visible" width="500px" @close="arrive_visible = false">
        <el-form v-if="arrive_visible" ref="containerForm" :model="arrivedForm" :rules="rules" label-width="120px" label-position="left">
          <template v-if="selectedPO=== 'Container'">
            <p>{{ $t('BusinessPurchaseOrder2.dialog.POId') }}: <span class="bold">{{ arrivedForm.code }}</span></p>
            <p>{{ $t('BusinessPurchaseOrder2.dialog.containerId') }}: <span class="bold">{{ arrivedForm.actualContainerNo }}</span></p>
          </template>
          <template v-else-if="showFCL.includes(selectedPO)">
            <p>{{ $t('BusinessPurchaseOrder2.dialog.hint1') }}  <span class="bold" style="color: green">{{ arrivedForm.containerId }}</span>  {{ $t('BusinessPurchaseOrder2.dialog.hint11') }}</p>
          </template>
          <template v-else>
            <p>{{ $t('BusinessPurchaseOrder2.dialog.hint2') }}  <span class="bold" style="color: green">{{ arrivedForm.thirdCode }}</span>  {{ $t('BusinessPurchaseOrder2.dialog.hint22') }}</p>
          </template>
          <!-- <el-radio-group v-if="selectedPO === 'Container'" v-model="arrivedForm.status" class="mt20 mb20">
            <el-radio label="Correct"><span class="bold" style="color: green">{{ $t('BusinessPurchaseOrder2.dialog.correctBtn') }}</span></el-radio>
            <el-radio label="Wrong"><span class="bold" style="color: red">{{ $t('BusinessPurchaseOrder2.dialog.wrongBtn') }}</span></el-radio>
          </el-radio-group> -->
          <el-row :gutter="20">
              <!-- <el-col v-if="arrivedForm.status === 'Wrong' && selectedPO=== 'Container'" :span="24">
                <el-form-item :label="$t('BusinessPurchaseOrder2.dialog.containerId')" prop="containerId">
                  <BjInput v-model="arrivedForm.containerId" clearable type="text" :placeholder="$t('BusinessPurchaseOrder2.dialog.inputText2')" @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col> -->
              <el-col v-if="!showArrivedInput" :span="24">
                <el-form-item :label="$t('BusinessPurchaseOrder2.dialog.arriveDate')" prop="arriveDate">
                  <BjDateTimerPicker v-model="arrivedForm.arriveDate" />
                </el-form-item>
              </el-col>
              <!-- <el-col v-if="selectedPO === 'Received' && arrivedForm.shippingMethod === 'Container'" :span="24">
                <el-form-item :label="$t('BusinessPurchaseOrder2.dialog.containerEndTime')" prop="containerEndTime">
                  <BjDatePicker v-model="arrivedForm.containerEndTime" />
                </el-form-item>
              </el-col> -->
            </el-row>
          </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="arrive_visible = false">{{ $t('cancelText') }}</el-button>
              <el-button type="primary" @click="arriveConfirm">{{ $t('okText') }}</el-button>
            </span>
    </BjDialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import { STORAGE_ORDER_STATUS_LIST, STORAGE_ORDER_STATUS_LIST2 } from '@/utils/constants';
import moment from 'moment';

export default {
  mixins: [pageMiXin],
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      colSpan: 6,
      queryApi: purchaseApi.getCsgPurchaseOrderList,
      // 查询参数
      queryParamsTime_finish: null,
      queryParams: {
        code: null,
        skuCode: null,
        containerId: null,
        status: this.isOpen ? ['New', 'Uploaded', 'Arrived', 'Receiving', 'Received', 'In Progress', 'UploadFail'] : ['Cancelled', 'Done'],
        finishTimeBegin: null,
        finishTimeEnd: null,
        cusId: null,
        deliveryTimeEnd: null
      },
      TAB_LIST: [
      {
          label: 'Open PO',
          value: 'open'
        },
        {
          label: 'Closed PO',
          value: 'close'
        }
      ],
      tabsValue: 'open',
      arrive_visible: false,
      selectedPO: null,
      arrivedForm: {
        status: null,
        arriveDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        containerId: null,
        code: null,
        actualContainerNo: null,
        shippingMethod: null,
        containerReadyTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        containerEndTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        thirdCode: null
      },
      // showVerifyBtn: ['Done', 'Arrived', 'Receiving', 'Received'],
      showFCL: ['Arrived', 'Receiving', 'Received', 'In Progress'],
      pickerOptions: {
        // 限制时间选择今天及以后的
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
        },
      },
      fclBtnType: null,
      labelsVersion: 0,
      labelList1: [
        { label: this.$t('BusinessPurchaseOrder2.code'), prop: 'code', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessAfterCsgReturn.table.cusName'), prop: 'cusId', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessPurchaseOrder2.Unit'), prop: 'shippingMethod', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('BusinessPurchaseOrder2.container'), prop: 'thirdCode', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('goodsBrand.page.Status'), prop: 'status', isCheck: true, disabled: false},
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.receiveDate'), prop: 'receiveDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.arrivedAt'), prop: 'deliveryTime', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.ConEmpDate'), prop: 'containerReadyTime', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.ConCollDate'), prop: 'containerEndTime', isCheck: true, disabled: false},
        // { label: this.$t('RefundOnlyToBeReviewed.form.Completion'), prop: 'finishTime', isCheck: true, disabled: false},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 135 },
      ],
      labelList2: [
        { label: this.$t('BusinessPurchaseOrder2.code'), prop: 'code', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessAfterCsgReturn.table.cusName'), prop: 'cusId', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessPurchaseOrder2.Unit'), prop: 'shippingMethod', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('BusinessPurchaseOrder2.container'), prop: 'thirdCode', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('goodsBrand.page.Status'), prop: 'status', isCheck: true, disabled: false},
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.receiveDate'), prop: 'receiveDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.arrivedAt'), prop: 'deliveryTime', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.ConEmpDate'), prop: 'containerReadyTime', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.ConCollDate'), prop: 'containerEndTime', isCheck: true, disabled: false},
        { label: this.$t('RefundOnlyToBeReviewed.form.Completion'), prop: 'finishTime', isCheck: true, disabled: false},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 135 },
      ],
      statusList: [],
      SHIPPING_METHODS: [
        {value: 'Container', label: 'Container'},
        {value: 'Pallet', label: 'Pallet'},
        {value: 'Carton', label: 'Carton'},
      ],
    };
  },
  computed: {
    labelList() {
      return this.isOpen ? this.labelList1 : this.labelList2;
    },
    statusOptionList() {
      return this.isOpen ? STORAGE_ORDER_STATUS_LIST : STORAGE_ORDER_STATUS_LIST2;
    },
    exportLabelList() {
      const dateProps = ['creationDate', 'receiveDate', 'deliveryTime', 'containerReadyTime', 'containerEndTime', 'finishTime'];
      return this.labelList.map(column => {
        if (column.prop === 'cusId') {
          return { ...column, export: { options: () => this.customerList } };
        }
        if (column.prop === 'thirdCode') {
          return { ...column, export: { formatter: (value, row) => row.shippingMethod == 'Container' ? row.containerId : row.thirdCode } };
        }
        return dateProps.includes(column.prop)
          ? { ...column, export: { dateFormat: 'DD/MM/YYYY HH:mm' } }
          : column;
      });
    },
    exportFileName() {
      return `inbound receipt ${moment().format('DD_MM_YYYY HH:mm')}.xls`;
    },
    rules() {
      return {
        arriveDate: [{ required: true, message: this.$t('BusinessPurchaseOrder2.dialog.inputText'), trigger: 'change' }],
        containerEndTime: [{ required: true, message: this.$t('BusinessPurchaseOrder2.dialog.inputText3'), trigger: 'change' }],
        containerId: [{ required: true, message: this.$t('BusinessPurchaseOrder2.dialog.inputText2'), trigger: 'blur' }],
      };
    },
    showArrivedInput() {
      return this.showFCL.includes(this.selectedPO);
    },
    arrivedDialogTitle() {
      let title = '';
      if (this.selectedPO === 'Container') { // container 类型到货
        title = this.$t('BusinessPurchaseOrder2.dialog.hint');
      } else if (this.showFCL.includes(this.selectedPO)) { // 出箱
        title = `${this.$t('BusinessPurchaseOrder2.dialog.hint')} ${this.arrivedForm.code}`;
      } else { // 其他 类型到货
        title = this.$t('BusinessPurchaseOrder2.dialog.hint');
      }
      return title;
    }
  },
  watch: {
    queryParamsTime_finish(v) {
      this.queryParams.finishTimeBegin = (v || [])[0];
      this.queryParams.finishTimeEnd = (v || [])[1];
    },
    statusList(val) {
      if (val.length > 0) {
        this.queryParams.status = val;
      } else {
        this.queryParams.status = this.isOpen ? ['New', 'Uploaded', 'Arrived', 'Receiving', 'Received', 'In Progress', 'UploadFail'] : ['Cancelled', 'Done'];
      }
    }
  },
  mounted() {},
  methods: {
    // 产品尺寸校验
    onVerify(row) {
      this.$router.push({ name: 'BusinessPurchaseOrderCsgAdminVerify', query: { id: row.id } });
    },
    // container 出箱
    onOutContainer(row) {
      this.fclBtnType = 'fclRdy';
      this.selectedPO = row.status;
      this.arrivedForm.code = row.code;
      this.arrivedForm.shippingMethod = row.shippingMethod;
      this.arrivedForm.thirdCode = row.thirdCode;
      this.arrivedForm.containerId = row.containerId;
      this.arrive_visible = true;
    },
    // 入库信息
    onReceive(row) {
      this.$router.push({
        name: 'BusinessPurchaseOrderCsgAdminReceive',
        query: { code: row.code, containerId: row.containerId, shippingMethod: row.shippingMethod}
      });
    },
    // 确认到货
    arriveConfirm() {
      if (this.selectedPO === 'Container') { // Container 类型 到货时间
        this.$refs.containerForm.validate(valid => {
          if (valid) {
            // if (!this.arrivedForm.status) return this.$message.error(this.$t('BusinessPurchaseOrder2.dialog.errMsg1'));
            const DATA = {
              code: this.arrivedForm.code,
              actualContainerNo: this.arrivedForm.actualContainerNo ? this.arrivedForm.actualContainerNo : this.arrivedForm.containerId,
              status: 1,
              deliveryTime: this.arrivedForm.arriveDate
            };
            this.toAPI(DATA);
            this.arrive_visible = false;
          } else {
            return false;
          }
        });
      } else if (this.showFCL.includes(this.selectedPO)) { // 出箱
        let DATA = {};
        if (this.fclBtnType === 'fclRdy') { // fcl Rdy按钮
            DATA = {
              code: this.arrivedForm.code,
              status: 2,
              containerReadyTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            };
        } else if (this.fclBtnType === 'fclPick') { // fcl Pick按钮
            DATA = {
              code: this.arrivedForm.code,
              status: 3,
              containerEndTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            };
        }
        this.toAPI(DATA);
        this.arrive_visible = false;
      } else { // 其他 类型 到货时间
        this.$refs.containerForm.validate(valid => {
          if (valid) {
            const DATA = {
              code: this.arrivedForm.code,
              status: 1,
              deliveryTime: this.arrivedForm.arriveDate
            };
            this.toAPI(DATA);
            this.arrive_visible = false;
          } else {
            return false;
          }
        });
      }
    },
    // 更新PO状态
    toAPI(DATA) {
      purchaseApi.updateCsgPurchaseOrder(DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    command(text, row) {
      switch (text) {
        case 'arrive':
          this.showArrived(row);
          break;
        case 'verify':
          this.onVerify(row);
          break;
        case 'receive':
          this.onReceive(row);
          break;
        case 'fclRdy':
          this.onOutContainer(row);
          break;
        case 'fclPick':
          this.onFclPick(row);
          break;
        case 'completed':
            this.toAPI({
              code: row.code,
              status: 4,
            });
          break;
        case 'push':
          this.onPushWMS(row);
          break;
        case 'edit':
          this.onEdit(row);
          break;
        case 'cancel':
          this.onCancel(row);
          break;
      }
    },
    // 推送到WMS
    onPushWMS(row) {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
      .then(_ => {
        purchaseApi['purchaseOrderPushToHJ']({
        id: row.id,
      }).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
      })
      .catch(_ => {});
    },
    // Fcl Pick
    onFclPick(row) {
      this.fclBtnType = 'fclPick';
      this.selectedPO = row.status;
      this.arrivedForm.code = row.code;
      this.arrivedForm.shippingMethod = row.shippingMethod;
      this.arrivedForm.thirdCode = row.thirdCode;
      this.arrivedForm.containerId = row.containerId;
      this.arrive_visible = true;
    },
    // 到货时间 弹窗
    showArrived(row) {
      this.arrivedForm.arriveDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      this.selectedPO = row.shippingMethod;
      this.arrivedForm.code = row.code;
      this.arrivedForm.thirdCode = row.thirdCode;
      this.arrivedForm.actualContainerNo = row.containerId;
      this.arrivedForm.containerId = null;
      this.arrivedForm.status = null;
      this.arrive_visible = true;
    },
    handleTabClick(tab) {
      this.tabsValue = tab.name;
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_finish = null;
      this.queryParamsTime_expected = null;
      this.queryParams.code = null;
      this.queryParams.containerId = null;
      this.queryParams.cusId = null;
      this.queryParams.thirdCode = null;
      this.queryParams.deliveryTimeEnd = null;
      this.statusList = [];
      this.queryParams.status = this.isOpen ? ['New', 'Uploaded', 'Arrived', 'Receiving', 'Received', 'In Progress', 'UploadFail'] : ['Cancelled', 'Done'];
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 新增 */
    onAdd() {
      this.$router.push({
        name: 'BusinessPurchaseOrderCsgAdminAdd',
      });
    },
    /** 修改 */
    onEdit(row) {
      const { id } = row;
      this.$toPage('BusinessPurchaseOrderCsgAdminEdit', {
        id,
      });
    },
    /** 取消 */
    onCancel(row) {
      this.$confirm(this.$t('InternalSalesOrderDetails.want'))
        .then(_ => {
          if (row.status !== 'New') return this.$message.warning(this.$t('BusinessPurchaseOrder2.dialog.errMsg2'));
          const DATA = {
            code: row.code,
            status: 0
          };
          this.toAPI(DATA);
        })
        .catch(_ => {});
    },
    resetAfterExport() {
      this.$refs.BjPage.onResetQuery();
    },
    /** 删除 */
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      // const result = this.selectedRows.some(item => item.status !== 'New');
      // if (result) return this.$message.warning(this.$t('BusinessPurchaseOrder2.hintMsg'));
      const ids = this.selectedRows.map(e => {
        return { id: e.id, objectVersionNumber: e.objectVersionNumber };
      });
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
      }).then(() => {
        this.batchDeleteApi(ids);
      });
    },
    // 更新状态 按钮
    onSync() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const result = this.selectedRows.some(item => item.status !== 'New' && item.status !== 'UploadFail');
      if (result) return this.$message.warning(this.$t('BusinessPurchaseOrder2.hintMsge'));

      purchaseApi.pushPurchaseOrderStatus(this.selectedRows.map(e => e.code)).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    onDetail(row) {
      this.$toPage('BusinessPurchaseOrderCsgAdminDetail', {
        id: row.id, status: this.isOpen ? 'open' : 'close', code: row.code
      });
    },
    batchDeleteApi(ids) {
      purchaseApi.delCsgPurchaseOrder({ ids }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 标红第一份 invoice
    rowStyleFun({ row, rowIndex }) {
      const styleJson = {};
      if (row.highlight) {
        styleJson.color = 'red';
      }
      return styleJson;
    },
    beforeQuerySearch(conditionObj) {
      const obj = {
        ...conditionObj
      };
      delete obj.currentPage;
      delete obj.pageSize;
      delete obj.total;
      return new Promise(resolve => {
        resolve(obj);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
::v-deep .el-dialog__body{
  padding-top: 0!important;
}
</style>
